const pptIcon = require('../assets/images/ppt.png')
const pdfIcon = require('../assets/images/pdf.png')
const wordIcon = require('../assets/images/word.png')
const zipIcon = require('../assets/images/zip.png')
const videoIcon = require('../assets/images/video.png')
const pptIconActive = require('../assets/images/ppt-active.png')
const pdfIconActive = require('../assets/images/pdf-active.png')
const wordIconActive = require('../assets/images/word-active.png')
const zipIconActive = require('../assets/images/zip-active.png')
const videoIconActive = require('../assets/images/video-active.png')

function _descriptionIsRethink (description) {
  return description.indexOf(SpecialString.rethink) !== -1
}

function _descriptionIsVideo (description) {
  return description.indexOf(SpecialString.video) !== -1
}

export const descriptionIsVideo = description => description.indexOf(SpecialString.video) !== -1

export const descriptionIsRethink = description => description.indexOf(SpecialString.rethink) !== -1

const SpecialString = {
  rethink: '3C2E82F537BC83138974119DCDF14183',
  video: '1B5EFA870666CD35A65A4CFE2A95F598'
}

const MATERIAL_TYPE = {
  DESCRIPTION: 'description',
  WORD: 'word',
  PPT: 'ppt',
  ZIP: 'zip',
  VIDEO: 'video',
  RE_THINK: 'reThink'
}

const Filetype = {
  word: 'word',
  ppt: 'ppt',
  pdf: 'pdf',
  video: 'mp4',
  zip: 'zip'
}

export const MATERIAL_AUDIT_STATUS = {
  rejected: {
    en: 'rejected',
    zh: '驳回'
  },
  refuse: {
    en: 'refuse',
    zh: '驳回'
  },
  approved: {
    en: 'approved',
    zh: '通过'
  },
  pending: {
    en: 'pending',
    zh: '审核中'
  }
}

// class UploadedFile {
//   constructor (id, fileSort, host, isSelected, originTitle, size, title, url) {
//     this.id = id
//     this.file_sort = fileSort
//     this.host = host
//     this.is_selected = isSelected
//     this.origin_title = originTitle
//     this.size = size
//     this.title = title
//     this.url = url
//   }

//   convertToRemoteFiles () {
//     const urls = this.url.split('\n')
//     const titles = this.origin_title.split('\n')
//     const sizes = this.size.split('\n')
//     return urls.map((url, index) => {
//       const name = index < titles.length ? titles[index] : ''
//       const size = index < sizes.length ? sizes[index] : ''
//       return new RemoteFile(name, this.host, url, size)
//     })
//   }
// }

class RemoteFile {
  constructor (name, host, path, size) {
    this.name = name
    this.host = host
    this.path = path
    this.size = size
  }

  static defaultRemoteFile () {
    return new RemoteFile('', '', '', '', '')
  }
}

class FileHolder {
  constructor (icon, activeIcon, type, remoteFile, id) {
    this.id = id
    this.icon = icon
    this.activeIcon = activeIcon
    this.type = type
    this.remoteFile = remoteFile
    this.updateDate = ''
  }
  updateWithUploadedFile (uploadFile) {
    this.id = uploadFile.id
  }

  setUpdateDate (updateDate) {
    this.updateDate = updateDate
  }

  asyncSelf (fileFromServer) {
    this.id = fileFromServer.id
    this.remoteFile = new RemoteFile(fileFromServer.title, fileFromServer.host, fileFromServer.url, fileFromServer.size)
    this.setUpdateDate(fileFromServer.update_time || '')
  }
  // 文件状态
  updateObjectWhenMaterialRejected (materialAuditStatus, lastUploadTime, materialId) {
    if (!lastUploadTime || !materialAuditStatus) {
      return { show: '', txt: '' }
    }
    if (materialAuditStatus === MATERIAL_AUDIT_STATUS.approved.en) {
      return { show: 'approve', txt: '【已通过】' }
    }
    if (!this.updateDate) {
      if (materialAuditStatus === MATERIAL_AUDIT_STATUS.refuse.en || materialAuditStatus === MATERIAL_AUDIT_STATUS.rejected.en) {
        return { show: 'reject', txt: '【被驳回】' }
      } else {
        return { show: '', txt: '' }
      }
    } else {
      const materialRejetedTimes = new Date(lastUploadTime.replace(/-/g, '/')).getTime()
      const updateTimes = new Date(this.updateDate.replace(/-/g, '/')).getTime()
      if (updateTimes > materialRejetedTimes) {
        // 判断时间不行 从缓存中取得
        const refuseAndUpdateFiles = localStorage.getItem('refuseAndUpdateFiles') ? JSON.parse(localStorage.getItem('refuseAndUpdateFiles')) : []
        if (refuseAndUpdateFiles.includes(`${materialId}-${this.type}`)) {
          return { show: 'update', txt: '【已更新】' }
        } else {
          return { show: 'reject', txt: '【被驳回】' }
        }
      } else {
        switch (materialAuditStatus) {
          case MATERIAL_AUDIT_STATUS.refuse.en:
          case MATERIAL_AUDIT_STATUS.rejected.en:
            return { show: 'reject', txt: '【被驳回】' }
          case MATERIAL_AUDIT_STATUS.approved.en:
            return { show: 'approve', txt: '【已通过】' }
          default:
            return { show: '', txt: '' }
        }
      }
    }
  }
}

class MaterialHodler {
  constructor (title, editable, placeholder, files, index, id, auditContent) {
    this.id = id
    this.title = title
    this.editable = editable
    this.placeholder = placeholder
    this.files = files
    this.index = index
    this.auditContent = auditContent
    this.auditStatus = ''
    this.rejectedDate = ''
  }

  updateWithUploadedFile (uploadFile) {
    this.title = uploadFile.title
    this.id = uploadFile.id
    const remoteFiles = uploadFile.convertToRemoteFiles()
    this.files.forEach((file, index) => {
      file.updateWithUploadedFile(uploadFile)
      if (index < remoteFiles.length) {
        file.remoteFile = remoteFiles[index]
      }
    })
  }

  asyncUpdate (dataFromServer, auditStatus) {
    this.auditStatus = auditStatus
    this.id = dataFromServer.id
    this.title = dataFromServer.title
    this.files.forEach(file => {
      const findFile = dataFromServer.resources.find(item => {
        // 针对仅材料环节有视频的情况
        if (file.type === 'mp4') {
          return item.category === 'word'
        } else if ((file.type.split(',').length > 1)) {
          return file.type.includes(item.category)
        }
        return item.category === file.type
      })
      if (findFile) {
        file.asyncSelf(findFile)
      }
    })
    // 如果是审核中那就不走
    if (auditStatus === MATERIAL_AUDIT_STATUS.pending.en) {
      return
    }
    if (dataFromServer.review_records && dataFromServer.review_records.length > 0) {
      this.rejectedDate = dataFromServer.review_records[0].create_time
      this.auditStatus = dataFromServer.review_records[0].audit_status
      const str = dataFromServer.review_records.reverse().reduce((cur, record) => {
        const recordDateTitle = record.audit_status === MATERIAL_AUDIT_STATUS.rejected.en ? `驳回时间：${record.create_time}<br/>` : `<span class='approved-text'>通过时间：${record.create_time}</span></span><br/>`
        const recordContents = record.audit_status === MATERIAL_AUDIT_STATUS.rejected.en ? `驳回理由：${record.content}<br/>` : ''
        cur += (recordDateTitle + recordContents)
        return cur
      }, '')
      this.auditContent = str
    }
  }
}

class MaterialSection {
  constructor (activityId, attachmentId, title, desc, type, materials) {
    this.activityId = activityId
    this.attachmentId = attachmentId
    this.title = title
    this.desc = desc
    this.type = type
    this.materials = materials
  }
  typeForServe () {
    switch (this.type) {
      case MATERIAL_TYPE.VIDEO:
      case MATERIAL_TYPE.RE_THINK:
        return MATERIAL_TYPE.WORD
      default:
        return this.type
    }
  }
}

// 需要上传材料要求
export const processingDefaultMaterial = materialList => {
  let plainWordSectionCount = 0
  return materialList.map(value => {
    const section = new MaterialSection(
      value.activity_id,
      value.id,
      '',
      value.desc.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>').replace(/\s/g, '&nbsp;'),
      value.file_type,
      []
    )
    const tempArray = Array.from(Array(value.num).keys())
    switch (section.type) {
      case MATERIAL_TYPE.DESCRIPTION:
        break
      case MATERIAL_TYPE.PPT:
        section.title = '教学设计、教学展示附件'
        section.materials = tempArray.map(i => {
          const pptFileHolder = new FileHolder(pptIcon, pptIconActive, Filetype.ppt, RemoteFile.defaultRemoteFile(), '')
          const pdfFileHolder = new FileHolder(pdfIcon, pdfIconActive, Filetype.pdf, RemoteFile.defaultRemoteFile(), '')

          let placeholder = value.activity_id === 847 ? '请输入教学设计标题，并注明学科课型' : '请输入教学设计材料标题'
          const materialHolder = new MaterialHodler(
            '',
            true,
            placeholder, //标注
            [pptFileHolder, pdfFileHolder], // fixme: 专门给江苏南大只上传ppt做的修改 【完事以后放开此行注释，删除下一行】
            // [pptFileHolder],
            i,
            ''
          )
          return materialHolder
        })
        break
      case MATERIAL_TYPE.ZIP:
        section.title = '说明文件（非必须）'
        section.materials = tempArray.map(i => {
          const zipFileHolder = new FileHolder(zipIcon, zipIconActive, Filetype.zip, RemoteFile.defaultRemoteFile(), '')
          const materialHolder = new MaterialHodler(
            '',
            false,
            '',
            [zipFileHolder],
            i,
            ''
          )
          return materialHolder
        })
        break
      case MATERIAL_TYPE.WORD:
        if (section.desc) {
          if (_descriptionIsRethink(section.desc)) {
            section.title = '上传教学反思'
            section.type = MATERIAL_TYPE.RE_THINK
          } else if (_descriptionIsVideo(section.desc)) {
            section.title = '上传教学视频'
            section.type = MATERIAL_TYPE.VIDEO
          }
        }
        if (section.type === MATERIAL_TYPE.WORD) {
          plainWordSectionCount += 1
          if (plainWordSectionCount === 1) {
            section.title = value.title || '上传教学大纲附件'
          } else if (plainWordSectionCount === 2) {
            section.title = value.title || '上传教学节段目录附件'
          } else {
            const rawDesc = (value.desc || '')
              .replace(/\r\n/g, ' ')
              .replace(/\n/g, ' ')
              .replace(/\s+/g, ' ')
              .replace(SpecialString.rethink, '')
              .replace(SpecialString.video, '')
              .trim()
            section.title = rawDesc || '上传附件'
          }
        }
        if (section.type === MATERIAL_TYPE.RE_THINK) {
          section.materials = tempArray.map(i => {
            const fileHolder = new FileHolder(wordIcon, wordIconActive, Filetype.word, RemoteFile.defaultRemoteFile(), '')
            const materialHolder = new MaterialHodler(
              '',
              false,
              '',
              [fileHolder],
              i,
              ''
            )
            return materialHolder
          })
        } else if (section.type === MATERIAL_TYPE.VIDEO) {
          section.materials = tempArray.map(i => {
            const fileHolder = new FileHolder(videoIcon, videoIconActive, Filetype.video, RemoteFile.defaultRemoteFile(), '')
            const materialHolder = new MaterialHodler(
              '',
              false,
              '',
              [fileHolder],
              i,
              ''
            )
            return materialHolder
          })
        } else {
          if (plainWordSectionCount === 1 || plainWordSectionCount === 2 || !value.urls || value.urls.length === 0) {
            section.materials = tempArray.map(i => {
              const fileHolder = new FileHolder(wordIcon, wordIconActive, Filetype.word, RemoteFile.defaultRemoteFile(), '')
              const materialHolder = new MaterialHodler(
                '',
                false,
                '',
                [fileHolder],
                i,
                ''
              )
              return materialHolder
            })
          } else {
            section.materials = value.urls.map((url, index) => {
            const fileHolder = new FileHolder(wordIcon, wordIconActive, Filetype.word, RemoteFile.defaultRemoteFile(), '')
            const materialHolder = new MaterialHodler(
              url.url,
              false,
              '',
              [fileHolder],
              index,
              ''
            )
            return materialHolder
            })
          }
        }
        section.materials = section.materials.filter(material => {
          return material.title !== '封面'
        })
        break
      default:
        break
    }
    return section
  }).filter(item => item.type !== MATERIAL_TYPE.ZIP || item.type !== MATERIAL_TYPE.DESCRIPTION)
}

/**
 * 处理用户上传资源，根据默认要求进行处理
 * @param {*} sections 默认要求
 * @param {*} uploaded 用户上传资源
 * @param {*} auditStatus 审核状态
 * @returns 
 */
function convertDefaultSectionsFromUploadedSectionsV3 (sections, uploaded, auditStatus) {
  const uploadedMapByAttachmentId = uploaded.reduce((map, item) => {
    if (!item) {
      return map
    }
    const attachmentId = item.attachment_id || item.attachmentId
    if (attachmentId === undefined || attachmentId === null || attachmentId === '') {
      return map
    }
    const key = String(attachmentId)
    // attachment_id 作为唯一键，重复时保留首条
    if (!map[key]) {
      map[key] = item
    }
    return map
  }, {})
  sections.forEach((value, index) => {
    const sectionAttachmentId = value && value.attachmentId ? String(value.attachmentId) : ''
    let uploadedWord = null

    if (sectionAttachmentId && uploadedMapByAttachmentId[sectionAttachmentId]) {
      uploadedWord = uploadedMapByAttachmentId[sectionAttachmentId]
    }
    if (uploadedWord === null) {
      return
    }
    let datas = uploadedWord.urls.filter(item => item.file_sort === 0)
    if (datas && datas.length > 1) {
      uploadedWord.urls.sort(function (a, b) {
        // 如果是老数据则file_sort均为默认值0，则根据id进行排序 ！注排序后还需要根据新数据修改file_sort
        if (a.file_sort === 0 && b.file_sort === 0) {
          return a.id - b.id
        }
        // 否则根据file_sort进行排序
        return a.file_sort - b.file_sort
      })
      uploadedWord.urls.forEach((item, index) => {
        // ！注排序后还需要根据新数据修改file_sort
        if (index !== 0 && item.file_sort === 0) {
          item.file_sort = index
        }
      })
    }
    value.materials.forEach((material) => {
      let uploadFile = uploadedWord.urls.filter(item => Number(item.file_sort) === Number(material.index))
      if (!uploadFile || uploadFile.length < 1) {
        return
      }
      const asyncMaterial = uploadFile[0]
      material.asyncUpdate(asyncMaterial, auditStatus)
    })
  })
}
// function convertDefaultSectionsFromUploadedSections (sections, uploaded) {
//   sections.forEach((value, index) => {
//     const uploadedWord = index < uploaded.length ? uploaded[index] : null
//     if (uploadedWord === null) {
//       return
//     }
//     let datas = uploadedWord.urls.filter(item => item.file_sort === 0)
//     if (datas && datas.length > 1) {
//       uploadedWord.urls.sort(function (a, b) {
//         // 如果是老数据则file_sort均为默认值0，则根据id进行排序 ！注排序后还需要根据新数据修改file_sort
//         if (a.file_sort === 0 && b.file_sort === 0) {
//           return a.id - b.id
//         }
//         // 否则根据file_sort进行排序
//         return a.file_sort - b.file_sort
//       })
//       uploadedWord.urls.forEach((item, index) => {
//         // ！注排序后还需要根据新数据修改file_sort
//         if (index !== 0 && item.file_sort === 0) {
//           item.file_sort = index
//         }
//       })
//     }
//     value.materials.forEach((material) => {
//       let uploadFile = uploadedWord.urls.map(item => {
//         return new UploadedFile(item.id, item.file_sort, item.host, item.is_selected, item.origin_title, item.size, item.title, item.url)
//       }).filter(item => Number(item.file_sort) === Number(material.index))

//       if (!uploadFile || uploadFile.length < 1) {
//         return
//       }
//       material.updateWithUploadedFile(uploadFile[0])
//     })
//   })
// }
/**
 * 处理用户上传资源，根据默认要求进行处理
 * @param {*} defaultList 默认要求
 * @param {*} detailList 用户上传资源
 * @param {*} auditStatus 审核状态
 * @returns 
 */
export const processingDetailWithDefaultData = (defaultList, detailList, auditStatus) => {
  const wordSections = defaultList.filter(item => item.type === MATERIAL_TYPE.WORD)
  const uploadedWordList = detailList.filter(item => item.file_type === MATERIAL_TYPE.WORD && !_descriptionIsVideo(item.desc) && !_descriptionIsRethink(item.desc))
  convertDefaultSectionsFromUploadedSectionsV3(wordSections, uploadedWordList, auditStatus)

  let rethinkSections = defaultList.filter(item => item.type === MATERIAL_TYPE.RE_THINK)
  let uploadedRethinkList = detailList.filter(item => item.file_type === MATERIAL_TYPE.WORD && _descriptionIsRethink(item.desc))
  convertDefaultSectionsFromUploadedSectionsV3(rethinkSections, uploadedRethinkList, auditStatus)

  let videoSections = defaultList.filter(item => item.type === MATERIAL_TYPE.VIDEO)
  let uploadedVideoList = detailList.filter(item => item.file_type === MATERIAL_TYPE.WORD && _descriptionIsVideo(item.desc))
  convertDefaultSectionsFromUploadedSectionsV3(videoSections, uploadedVideoList, auditStatus)

  let pptSections = defaultList.filter(item => item.type === MATERIAL_TYPE.PPT)
  let uploadedPptList = detailList.filter(item => item.file_type === MATERIAL_TYPE.PPT)
  convertDefaultSectionsFromUploadedSectionsV3(pptSections, uploadedPptList, auditStatus)

  return wordSections.concat(pptSections).concat(rethinkSections).concat(videoSections)
}

export const processingLocalDataToService = (materialList, typesItemIndex, fileItemIndex, index, activityId, playerId, opt, rejectFileIds) => {
  let material = materialList[typesItemIndex]
  let obj = {
    file_type: material.typeForServe(),
    category: 'player',
    activity_id: Number(activityId),
    user_id: playerId,
    desc: material.desc,
    urls: []
  }
  if (material.attachmentId) {
    obj.attachment_id = material.attachmentId
  }
  if (material.id) {
    obj.id = material.id
  }
  let file = material.materials[fileItemIndex]
  if (rejectFileIds && rejectFileIds.length > 0 && rejectFileIds.indexOf(String(file.id)) === -1) { // 审核拒绝后重新提交的文件未非拒绝文件id
    return { errorType: 'unRejectedFile', errorMsg: '非审核拒绝文件不能重新提交！' }
  }
  let fileObj = {
    title: file.title,
    file_sort: fileItemIndex
  }
  if (file.id) {
    fileObj.id = file.id
  }
  if (material.type === 'ppt' || file.files.length === 2) { // PPT PDF
    if (opt === 'delete') { // 删除附件
      if (file.files[index]) {
        file.files[index].remoteFile.path = ''
        file.files[index].remoteFile.size = ''
        file.files[index].remoteFile.name = ''
      }
      fileObj.url = file.files[0].remoteFile.path + '\n' + file.files[1].remoteFile.path
      fileObj.size = file.files[0].remoteFile.size + '\n' + file.files[1].remoteFile.size
      fileObj.origin_title =
        file.files[0].remoteFile.name + '\n' + file.files[1].remoteFile.name
    } else { // 添加或更新
      if (!file.files[0].remoteFile.path || !file.files[1].remoteFile.path || !file.title) {
        return { errorType: 'uncomplete', errorMsg: '' }
      }
      fileObj.url = file.files[0].remoteFile.path + '\n' + file.files[1].remoteFile.path
      fileObj.size = file.files[0].remoteFile.size + '\n' + file.files[1].remoteFile.size
      fileObj.origin_title =
        file.files[0].remoteFile.name + '\n' + file.files[1].remoteFile.name
    }
  } else { // 其他文件类型
    fileObj.url = opt === 'delete' ? '' : file.files[0].remoteFile.path
    fileObj.size = opt === 'delete' ? '' : String(file.files[0].remoteFile.size)
    fileObj.origin_title = opt === 'delete' ? '' : file.files[0].remoteFile.name
  }
  obj.urls.push(fileObj)
  return obj
}

export const uploadFailedProcessingData = (materialList, typesItemIndex, fileItemIndex, opt) => {
  let material = materialList[typesItemIndex]
  let file = material.materials[fileItemIndex]
  if (opt !== 'delete') { // 添加或更新，失败后需要清空当前操作课时数据，从而重新提交
    file.files.forEach(item => {
      if (item && item.remoteFile) {
        item.remoteFile.path = ''
        item.remoteFile.size = ''
        item.remoteFile.name = ''
      }
    })
  }
}
export const removeSpecialString = (desc) => {
  return desc.replace(SpecialString.rethink, '').replace(SpecialString.video, '')
}
export { MATERIAL_TYPE }



// WEBPACK FOOTER //
// ./src/model/processingData.js